import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {
  Icon, SecondaryTextSm, FilterCounter, BorderlessKeyInput, ClickableIcon,
  BoldMatchText, SecondaryTextXs, SecondaryTextXsBold
} from 'atoms';
import {
  CustomBackgroundWrapper, Mr2, FlexCenterJustifyCenterWrapper, W50, GenericWrapper,
  FlexCenterBetweenWrapper, Mr3, FlexCenterWrapper, W100, Ml6, RelativeWrapper,
  AbsoluteLeftTopWrapper, CustomBorderWrapper, MaxWidthHeight, FullWIdthColumnScrollWrapper,
  FullWidthFlexBoxWrapper, Py2, CursorPointerWrapper, HoverPrimary50BackgroundWrapper,
  Width200, Mt3, Ml4, Pl4, Mr1, Mr4
} from 'wrappers';
import {
  PipeSvg, MagnifyingGlassSvg, MoreFiltersSvg, XSvg, RefreshArrowSvg, CloseSvg
} from 'components/icons';
import { getCookie } from "utils/cookies";
import { boldMatchCharacters } from 'utils';
import { textEllipsis } from 'utils/ellipsis';

export const definition = {
  name: 'MobilePageSearch',
  controller: Controller,
  initialProps: ({ filtersCount, suggestions, placeholder, searchTerm, inputVal, showDropdown, isLoadingSuggestions }) => {
    let recentSearches = (inputVal && JSON.parse(getCookie("recent_searches"))?.filter(s => s.toLowerCase().includes(inputVal.toLowerCase()))?.slice(0, 3)) ?? [];
    return { filtersCount, suggestions, placeholder, searchTerm, inputVal, recentSearches, showDropdown, isLoadingSuggestions }
  },
  props: internalState,
  elements: [
    {
      wrapper: CustomBackgroundWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      displayState: ({ }) => ({ height: '37px', width: '100%', background: '#F3F5F5', alignItems: 'center' }),
      elements: [
        {
          wrapper: wrap(FlexCenterJustifyCenterWrapper, W50),
          name: 'SearchButton',
          isButton: true,
          renderIf: ({ isToggled }) => !isToggled,
          bindings: ({ containerRef, inputRef }) => ({ containerRef, inputRef }),
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              displayValue: ({ }) => MagnifyingGlassSvg({ color: window?.settings?.secondary_color ?? '#04333B', width: 13, height: 13 })
            },
            {
              component: SecondaryTextSm,
              name: 'Text',
              displayValue: ({ }) => 'Search'
            },
          ]
        },
        {
          component: Icon,
          renderIf: ({ isToggled }) => !isToggled,
          name: 'Pipe',
          displayValue: ({ }) => PipeSvg({ color: '#C2CCCE' })
        },
        {
          wrapper: wrap(FlexCenterJustifyCenterWrapper, W50),
          name: 'FiltersButton',
          renderIf: ({ isToggled }) => !isToggled,
          isButton: true,
          bindings: ({ }) => ({}),
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              displayValue: ({ }) => MoreFiltersSvg({ color: window?.settings?.secondary_color ?? '#04333B', width: 14, height: 14 })
            },
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'Text',
              displayValue: ({ }) => 'Filter'
            },
            {
              component: FilterCounter,
              name: 'Count',
              renderIf: ({ filtersCount }) => !!filtersCount,
              displayValue: ({ filtersCount }) => filtersCount
            },
          ]
        },
        {
          wrapper: wrap(FlexCenterBetweenWrapper, W100),
          name: 'Search',
          renderIf: ({ isToggled }) => isToggled,
          elements: [
            {
              wrapper: GenericWrapper,
              name: 'SearchWrapper',
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: wrap(wrap(BorderlessKeyInput, Mr3), Ml6),
                  name: 'SearchInput',
                  displayState: ({ }) => ({ background: '#F3F5F5' }),
                  bindings: ({ inputVal, placeholder, showDropdown }) => ({ showDropdown, value: inputVal, placeholder: placeholder ?? "Search..." })
                },
              ]
            },
            {
              wrapper: FlexCenterWrapper,
              name: 'ButtonsWrapper',
              elements: [
                {
                  component: wrap(ClickableIcon, Mr3),
                  bindings: ({ }) => ({}),
                  name: 'Close',
                  displayValue: ({ }) => XSvg({ color: window?.settings?.secondary_color ?? '#04333B', width: 14, height: 14 })
                },
                {
                  wrapper: CustomBackgroundWrapper,
                  name: 'Search',
                  isButton: true,
                  bindings: ({ inputVal }) => ({ inputVal }),
                  displayState: ({ }) => ({ borderRadius: '10px 0px 0px 10px', height: '37px', width: '57px', background: window?.settings?.primary_color ?? '#1DBD6B', alignItems: 'center', justifyContent: 'center' }),
                  elements: [
                    {
                      component: Icon,
                      name: 'Icon',
                      displayValue: ({ }) => MagnifyingGlassSvg({ color: '#FFFFFF', width: 16, height: 16 })
                    },
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      wrapper: CustomBackgroundWrapper,
      name: 'SearchWrapper',
      renderIf: ({ searchTerm }) => !!searchTerm,
      displayState: ({ }) => ({ height: '47px', width: '100%', background: `${window?.settings?.primary_color ?? '#1DBD6B'}0D`, alignItems: 'center' }),
      elements: [
        {
          wrapper: wrap(FlexCenterJustifyCenterWrapper, W100),
          name: 'TextWrapper',
          elements: [
            {
              component: wrap(SecondaryTextXs, Mr1),
              name: 'Text',
              displayValue: ({ }) => 'Search results for'
            },
            {
              component: SecondaryTextXsBold,
              name: 'SearchTerm',
              displayValue: ({ searchTerm }) => `"${textEllipsis(searchTerm, 10)}"`
            }
          ]
        },
        {
          component: wrap(ClickableIcon, Mr4),
          name: 'Close',
          bindings: ({ }) => ({}),
          displayValue: ({ }) => CloseSvg({})
        }
      ]
    },
    {
      wrapper: AbsoluteLeftTopWrapper,
      displayState: ({ }) => ({ top: '50px' }),
      renderIf: ({ isOpen }) => isOpen,
      name: 'DropdownWrapper',
      elements: [
        {
          wrapper: wrap(CustomBorderWrapper, Pl4),
          name: 'BorderWrapper',
          displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF', padding: '18px' }),
          elements: [
            {
              wrapper: MaxWidthHeight,
              name: 'BodyWrapper',
              displayState: ({ }) => ({ height: '335px', display: 'flex' }),
              renderIf: ({ isOpen }) => isOpen,
              elements: [
                {
                  wrapper: wrap(FullWIdthColumnScrollWrapper, FullWidthFlexBoxWrapper),
                  name: 'Body',
                  elements: [
                    {
                      wrapper: wrap(wrap(wrap(FlexCenterWrapper, Py2), CursorPointerWrapper), HoverPrimary50BackgroundWrapper),
                      name: 'RecentSearchRow',
                      isButton: true,
                      isListOf: { recentSearch: ({ recentSearches }) => recentSearches?.length > 0 ? recentSearches : [] },
                      bindings: ({ recentSearch }) => ({ suggestion: recentSearch }),
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => RefreshArrowSvg({ color: '#9EACB0' })
                        },
                        {
                          component: wrap(BoldMatchText, Width200),
                          name: 'Text',
                          displayValue: ({ recentSearch, inputVal }) => boldMatchCharacters({ text: textEllipsis(recentSearch, 30), match: inputVal })
                        }
                      ]
                    },
                    {
                      wrapper: wrap(wrap(wrap(FlexCenterWrapper, Py2), CursorPointerWrapper), HoverPrimary50BackgroundWrapper),
                      name: 'Row',
                      renderIf: ({ isLoadingSuggestions }) => !isLoadingSuggestions,
                      isButton: true,
                      isListOf: { suggestion: ({ recentSearches, suggestions }) => suggestions.filter(s => !recentSearches.includes(s)).slice(0, 8 - recentSearches.length) ?? [] },
                      bindings: ({ suggestion }) => ({ suggestion }),
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => MagnifyingGlassSvg({ color: '#9EACB0' })
                        },
                        {
                          component: wrap(BoldMatchText, Width200),
                          name: 'Text',
                          displayValue: ({ suggestion, inputVal }) => boldMatchCharacters({ text: textEllipsis(suggestion, 30), match: inputVal })
                        }
                      ]
                    },
                    {
                      component: wrap(wrap(SecondaryTextXs, Mt3), Ml4),
                      name: 'Loading',
                      renderIf: ({ isLoadingSuggestions }) => isLoadingSuggestions,
                      displayValue: ({ }) => 'Searching suggestions...'
                    },
                    {
                      component: wrap(wrap(SecondaryTextXs, Mt3), Ml4),
                      name: 'Loading',
                      renderIf: ({ isLoadingSuggestions, suggestions }) => !isLoadingSuggestions && suggestions.length === 0,
                      displayValue: ({ }) => 'No search suggestions found'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }

  ]
};

export default wrap(ContainerComponent(definition), RelativeWrapper);